import React from "react";

function NewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
    >
      <path
        d="M2.20469 2.25C2.20469 1.65326 2.43647 1.08097 2.84905 0.65901C3.26163 0.237053 3.82121 0 4.40469 0C4.98816 0 5.54774 0.237053 5.96032 0.65901C6.3729 1.08097 6.60469 1.65326 6.60469 2.25C6.60469 2.84674 6.3729 3.41903 5.96032 3.84099C5.54774 4.26295 4.98816 4.5 4.40469 4.5C3.82121 4.5 3.26163 4.26295 2.84905 3.84099C2.43647 3.41903 2.20469 2.84674 2.20469 2.25ZM0.554688 8.47793C0.554688 6.74648 1.92625 5.34375 3.61922 5.34375H5.19016C6.88313 5.34375 8.25469 6.74648 8.25469 8.47793C8.25469 8.76621 8.02609 9 7.74422 9H1.06516C0.783281 9 0.554688 8.76621 0.554688 8.47793ZM9.21719 5.48438V4.35938H8.11719C7.88859 4.35938 7.70469 4.17129 7.70469 3.9375C7.70469 3.70371 7.88859 3.51562 8.11719 3.51562H9.21719V2.39062C9.21719 2.15684 9.40109 1.96875 9.62969 1.96875C9.85828 1.96875 10.0422 2.15684 10.0422 2.39062V3.51562H11.1422C11.3708 3.51562 11.5547 3.70371 11.5547 3.9375C11.5547 4.17129 11.3708 4.35938 11.1422 4.35938H10.0422V5.48438C10.0422 5.71816 9.85828 5.90625 9.62969 5.90625C9.40109 5.90625 9.21719 5.71816 9.21719 5.48438Z"
        fill="#F97316"
      />
    </svg>
  );
}

export default NewIcon;
